import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PPIInvestmentThemeFormComponent from './theme-form-component';
import * as actions from '../../../../actions';
import PPIInvestmentThemeService from '../../../../service/sfp/ppi-investment-theme-service';

class InvestmentThemeFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: undefined, 
			submitting: false,
			name: ""
		};
	}

	componentDidMount() {
		if (this.props.theme) this.setState({name: this.props.theme.name, user: this.props.theme.responsible ? this.props.theme.responsible.id : undefined})
	}

	render() {
		return (
			<PPIInvestmentThemeFormComponent
				name					= {this.state.name}
				user					= {this.state.user}
				users					= {this.props.users}
				delete				= {this.props.delete}
				onUserChange	= {(e) => {this.setState({user: e.target.value})}}
				onNameChange	= {(e) => {e.constructor === String ?this.setState({name: e}):this.setState({name: e.target.value})}}
				theme					= {this.props.theme}
				parentTheme		= {this.props.parentTheme}
				onSubmit      = {this._handleSubmit}
				submitting    = {this.state.submitting}
			/>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })

		const ppi_theme = {
			name: event.target.name.value,
			responsible: event.target.user ? event.target.user.value : null,
		}

		if (!this.props.theme) {
			ppi_theme["ppi"] = this.props.ppi.id
		}
		if  (this.props.parentTheme) {
			ppi_theme["parent"] = (this.props.parentTheme ? this.props.parentTheme.id : this.props.theme.parent.id)
			ppi_theme["ppi"] = null
		}

		if (this.props.delete) {
			PPIInvestmentThemeService.deletePPIInvestmentTheme(this.props.theme)
				.then(this._resolveDeleteInvestmentTheme.bind(this, event), this._rejectDeleteInvestmentTheme)
		} else if (this.props.theme) {
			PPIInvestmentThemeService.updatePPIInvestmentTheme(this.props.theme.id, ppi_theme)
				.then(this._resolveUpdateInvestmentTheme.bind(this, event), this._rejectUpdateInvestmentTheme)
		} else {
			PPIInvestmentThemeService.createPPIInvestmentTheme(ppi_theme)
				.then(this._resolveCreateInvestmentTheme.bind(this, event), this._rejectCreateInvestmentTheme)
		}
	}

	_rejectCreateInvestmentTheme = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveCreateInvestmentTheme = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onCreated(response)
		})
	}

	_rejectUpdateInvestmentTheme = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveUpdateInvestmentTheme = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onUpdated(response)
		})
	}

	_rejectDeleteInvestmentTheme = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveDeleteInvestmentTheme = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onDeleted(response)
		})
	}



}

const mapDispatchToProps = dispatch => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(null, mapDispatchToProps)(InvestmentThemeFormContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/theme-form-container.js